import {
  PUBLISHED_PREFIX,
  DEFAULT_SHIPPING_ADDRESS,
  DEFAULT_BILLING_ADDRESS,
  DEFAULT_BILLING_SHIPPING_ADDRESS
} from './constants';

const addModifier = (className, modifier) => (modifier ? `${className} ${modifier}` : className);

const getCartItemsTotal = cartItems => {
  let total = 0;
  cartItems.forEach(({ quantity }) => {
    total += quantity;
  });
  return total.toString();
};

const getFromLocalStorage = localKey =>
  typeof localStorage !== 'undefined' && localStorage.getItem(localKey);

const addPublishedEntityPrefix = entityIdentifier => `${PUBLISHED_PREFIX}${entityIdentifier}`;

const updateCartLineItems = (lineItems, productId, variantId, value) =>
  lineItems.map(lineItem => {
    const { productId: currentId, variantId: currentVariant, quantity: currentQuantity } = lineItem;
    const isMatch = currentId === productId && currentVariant === variantId;
    const quantityToUse = isMatch ? value : currentQuantity;

    return { productId: currentId, variantId: currentVariant, quantity: Number(quantityToUse) };
  });

const buildAddressString = (address, prefix = false) => {
  if (!address) return '';

  const {
    firstname,
    lastname,
    company,
    address1,
    address2,
    city,
    country = '',
    countryName = '',
    county = '',
    countyName = '',
    postcode,
    isDefaultBilling,
    isDefaultShipping
  } = address;
  let prefixString = '';
  if (prefix) {
    if (isDefaultBilling && isDefaultShipping) {
      prefixString = DEFAULT_BILLING_SHIPPING_ADDRESS;
    } else if (isDefaultBilling) {
      prefixString = DEFAULT_BILLING_ADDRESS;
    } else if (isDefaultShipping) {
      prefixString = DEFAULT_SHIPPING_ADDRESS;
    }

    prefixString = prefixString ? `${prefixString}: ` : '';
  }
  const name = [firstname, lastname].filter(Boolean).join(' ');
  const addressString = [
    name,
    company,
    address1,
    address2,
    countryName || country,
    countyName || county,
    city,
    postcode
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <>
      {prefixString && (
        <span className="blaze-ecommerce-address-list__item--label">{prefixString}</span>
      )}
      {addressString}
    </>
  );
};

const formatAddress = (address, forCompare = false) => {
  if (!address) return null;

  const getAddressValue = value => {
    if (!forCompare) return value;

    return value || '';
  };

  return {
    id: forCompare ? null : address.id,
    title: getAddressValue(address.title),
    firstname: getAddressValue(address.firstname),
    lastname: getAddressValue(address.lastname),
    company: getAddressValue(address.company),
    address1: getAddressValue(address.address1),
    address2: getAddressValue(address.address2),
    city: getAddressValue(address.city),
    country: getAddressValue(address.country),
    county: getAddressValue(address.county),
    postcode: getAddressValue(address.postcode),
    tel: getAddressValue(address.tel)
  };
};

const getVariantMinMaxQuantity = (variantId, variants) => {
  if (!variantId || !variants || !variants.length) return {};
  const selectedVariant = variants.find(({ variantId: vId }) => variantId === vId) || {};
  return {
    minQuantity: selectedVariant.minQuantity,
    maxQuantity: selectedVariant.maxQuantity
  };
};

export {
  addModifier,
  addPublishedEntityPrefix,
  buildAddressString,
  getCartItemsTotal,
  getFromLocalStorage,
  getVariantMinMaxQuantity,
  updateCartLineItems,
  formatAddress
};
